import { PackageMonitoringEntity } from '@/features/trackOrder/domain/entities/packageEntites/PackageMonitoringEntity'
import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MonitoringPackageAddressModel } from './MonitoringPackageAddressModel'
import type { PackageMonitoringAdminDto } from '@/backend/market'
import type { MonitoringPackageAddressEntity } from '@/features/trackOrder/domain/entities/packageEntites/MonitoringPackageAddressEntity'

export class PackageMonitoringModel extends PackageMonitoringEntity {
  constructor(dataDto: PackageMonitoringAdminDto) {
    super()
    mapEntityProperties<PackageMonitoringModel>(this, dataDto, {
      map: {
        address: dataDto.address
          ? new MonitoringPackageAddressModel(dataDto.address as MonitoringPackageAddressEntity)
          : undefined,
        vehicleTemplateType: dataDto.vehicleTemplateType
      }
    })
  }
}
